// <s-disclosure-toggle> wraps a button whose aria-controls names a panel; clicking shows or hides that panel, and Escape closes it.
class DisclosureToggle extends HTMLElement {
  #abort = new AbortController();

  connectedCallback() {
    const button = this.querySelector('button[aria-controls]');
    const panel = button && document.getElementById(button.getAttribute('aria-controls'));
    if (!button || !panel) return;
    const { signal } = this.#abort;
    const setOpen = (open) => {
      button.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
    };
    button.addEventListener('click', () => setOpen(button.getAttribute('aria-expanded') !== 'true'), { signal });
    panel.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      setOpen(false);
      button.focus();
    }, { signal });
  }

  disconnectedCallback() {
    this.#abort.abort();
  }
}

if (!customElements.get('s-disclosure-toggle')) customElements.define('s-disclosure-toggle', DisclosureToggle);
